export default __webpack_public_path__ + "static/media/640_store04-en-web.30417a62.png";